<template>
    <router-link :to="route" :class="{ 'is-active': isActive }" @click="closeMenu"> Gradebook </router-link>
</template>

<script>
import ActiveStatusMixin from '@/mixins/ActiveStatus.mixin.js';
import Course from '@/models/Course.js';

export default {
    name: 'NestedGradebook',

    mixins: [ActiveStatusMixin],

    props: {
        closeMenu: {
            type: Function,
            default: () => {},
        },

        course: {
            type: Course,
            required: true,
        },
    },

    computed: {
        route() {
            return {
                name: 'gradebook-view',
                params: {
                    courseId: this.course.id,
                    gradebookId: this.course.gradebook.id,
                },
            };
        },
    },
};
</script>
